import { RoutesNames } from './navigationRoutes';
import { Route, Navigate } from 'react-router-dom';
import { LoggedInLayout } from './LoggedInLayout';
import { ROLES } from '@/shared/config/constants';

import PageLive from '@/pages/Page-Live';
import PageHome from '@/pages/Page-Home';
import PageOrders from '@/pages/Page-Orders';
import { lazyWithSuspense } from '@/shared/lazyWithSuspense';
import { preloadLazy } from '@/utils/preload-lazy';

const PageDocs = lazyWithSuspense(() => import('@/pages/Page-Docs'), null, null);
const PageAdmins = lazyWithSuspense(() => import('@/pages/Page-Admins'), null, null);
const PageCities = lazyWithSuspense(() => import('@/pages/Page-Cities'), null, null);
const PageDashboard = lazyWithSuspense(() => import('@/pages/Page-Dashboard'), null, null);
const PageDelivery = lazyWithSuspense(() => import('@/pages/Page-Delivery'), null, null);
const PageCatalog = lazyWithSuspense(() => import('@/pages/Page-Catalog'), null, null);
const PageSettings = lazyWithSuspense(() => import('@/pages/Page-Settings'), null, null);
const PageShops = lazyWithSuspense(() => import('@/pages/Page-Shops'), null, null);
const PageStatistics = lazyWithSuspense(() => import('@/pages/Page-Statistics'), null, null);
const PageMessages = lazyWithSuspense(() => import('@/pages/Page-Messages'), null, null);

export const getRoutesBasedOnPermissions = user => {
	try {
		switch (user?.role) {
			case ROLES.MASTER:
				preloadLazy(PageDelivery);
				preloadLazy(PageShops);
				preloadLazy(PageSettings);

				return (
					<Route path='/' element={<LoggedInLayout />}>
						<Route index path={RoutesNames.HOME} element={<PageHome />} />
						<Route path={RoutesNames.DOCS} element={<PageDocs />} />

						<Route path={RoutesNames.LIVE} element={<PageLive />} />
						<Route path={RoutesNames.ORDERS} element={<PageOrders />} />
						<Route path={RoutesNames.CATALOG} element={<PageCatalog />} />
						<Route path={RoutesNames.DELIVERY} element={<PageDelivery />} />

						<Route path={RoutesNames.SETTINGS} element={<PageSettings />} />
						<Route path={RoutesNames.SHOPS} element={<PageShops />} />
						<Route path={RoutesNames.STATISTICS} element={<PageStatistics />} />
						<Route path={RoutesNames.MESSAGES} element={<PageMessages />} />

						<Route path={RoutesNames.CITIES} element={<PageCities />} />
						<Route path={RoutesNames.ADMINS} element={<PageAdmins />} />
						<Route path={RoutesNames.DASHBOARD} element={<PageDashboard />} />

						<Route path='*' element={<Navigate to={RoutesNames.HOME} />} />
					</Route>
				);

			case ROLES.ADMIN:
				preloadLazy(PageDelivery);
				preloadLazy(PageShops);
				preloadLazy(PageSettings);
				return (
					<Route path='/' element={<LoggedInLayout />}>
						<Route index path={RoutesNames.HOME} element={<PageHome />} />
						<Route path={RoutesNames.DOCS} element={<PageDocs />} />

						<Route path={RoutesNames.LIVE} element={<PageLive />} />
						<Route path={RoutesNames.ORDERS} element={<PageOrders />} />

						<Route path={RoutesNames.CATALOG} element={<PageCatalog />} />
						<Route path={RoutesNames.DELIVERY} element={<PageDelivery />} />

						<Route path={RoutesNames.SETTINGS} element={<PageSettings />} />
						<Route path={RoutesNames.SHOPS} element={<PageShops />} />
						<Route path={RoutesNames.STATISTICS} element={<PageStatistics />} />
						<Route path={RoutesNames.MESSAGES} element={<PageMessages />} />

						{user?.managerLevel === 1 && (
							<Route path={RoutesNames.ADMINS} element={<PageAdmins />} />
						)}

						<Route path='*' element={<Navigate to={RoutesNames.HOME} />} />
					</Route>
				);

			case ROLES.SHOP:
				return (
					<Route path='/' element={<LoggedInLayout />}>
						<Route index path={RoutesNames.HOME} element={<PageHome />} />
						<Route path={RoutesNames.DOCS} element={<PageDocs />} />

						<Route path={RoutesNames.LIVE} element={<PageLive />} />
						<Route path={RoutesNames.ORDERS} element={<PageOrders />} />

						<Route path={RoutesNames.CATALOG} element={<PageCatalog />} />

						<Route path='*' element={<Navigate to={RoutesNames.HOME} />} />
					</Route>
				);

			default:
				return (
					<>
						<Route index path={RoutesNames.HOME} element={<PageHome />} />
						<Route path={RoutesNames.DOCS} element={<PageDocs />} />

						<Route path='*' element={<Navigate to={RoutesNames.HOME} />} />
					</>
				);
		}
	} catch (error) {
		console.log('getRoutesBasedOnPermissions error:', error);
	}
};
